// extracted by mini-css-extract-plugin
export default {"root":"styles_root__I7tBF","item":"styles_item__whXst"};